import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ContractRenameWorkflow } from "./ContractRenameWorkflow";

type Props = {
  open: boolean;
  globalEventId: number;
  onClose: () => void;
  onApplied: () => void;
};

export function ContractRenameDialog({ open, globalEventId, onClose, onApplied }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>Rename event contract name</DialogTitle>
      <IconButton
        aria-label="Close"
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <ContractRenameWorkflow
          embedded
          lockAnchorId
          initialGlobalEventId={globalEventId}
          onApplied={() => {
            onApplied();
            onClose();
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
